import React, { forwardRef, useState, useEffect, createRef }  from 'react';
import { Colors } from '../../../constants';
import PhoneDefaultElement from './PhoneDefaultElement';

const SelectDropdown = forwardRef((props, ref) => {
    const [ focusBorderColor, setFocusBorderColor ] = useState(`#${Colors.primaryColor}`);
    const [ phoneNumberElement, setPhoneNumberElement ] = useState(null);

    useEffect(() => {
        setFocusBorderColor(`#${Colors.disabledText}`);
    },
    []);

    function changedSelectDropdown (value) {
        if (props.data['name'] === 'Location') {
            if (value === 'Phone Call') {
                showPhoneNumberField();
            } else {
                setPhoneNumberElement(null);
                props.elementRefs.current['location-options-phone-call'] = null;
            }
        }
    }

    function showPhoneNumberField () {
        if (!props.isPhoneNumberElementExists) {
            let refName = 'location-options-phone-call';
            props.elementRefs.current[refName] = createRef(refName);
            setPhoneNumberElement(<PhoneDefaultElement
                    ref={props.elementRefs.current[refName]}
                    countryCode={props.countryCode}
                    index={'location-options-phone-call'}
                    number={props.paramsInputNumber || ''}
                    permittedCountries={props.permittedCountries}
                    customDisplayedCountries={props.customDisplayedCountries}
                    defaultCountry={props.defaultCountry}
                    handleOnChange={(number) => props.handleOnChange(number)}
                    color={props.color} />);
        }
    }

    let text_default_value = props.URL_PARAMS.get(props.data['name'].toLowerCase()?.split(" ").join("_"));
    if(text_default_value !== null){
        text_default_value = text_default_value?.split("_").join(" ") || "";
    }


    let content=[];
    let id=`dropdown${props.index}`;
    let url = props.data['name'].toLowerCase()?.split(" ").join("_");
    if(url[url.length-1] === '_') {
        url = url.slice(0, -1);
    }
    let dropdown_default_value = props.URL_PARAMS.get(url) || "";

    if(typeof(props.data['content'])===undefined){
        return <div></div>
    }

    for(let y=0; y<props.data['content'].length; y++){
        content.push(
            <option className="option-pick" value={props.data['content'][y]} key={y+1}>
                {props.data['content'][y]}
            </option>
        )
    }

    return(
        <div className="input-section" key={props.index}>
            <div className="input-nav field-label">
                <label>
                    {props.data['name']}

                    { props.data['required'] && (
                        <span className="required" style={{ color: props.color }}> *</span>
                    )}
                </label>
                <div className="field-input full-border">
                    <select
                        required={props.data['required']}
                        ref={ref}
                        id={id}
                        className="select-nav"
                        defaultValue={dropdown_default_value}
                        style={{ borderColor: focusBorderColor }}
                        onFocus={ () => setFocusBorderColor(props.color) }
                        onChange={(e) => changedSelectDropdown(e.target.value)}
                        onBlur={ () => setFocusBorderColor(`#${Colors.disabledText}`) } >
                        <option value="" key="0" style={{display:'none'}}>-- Select {props.data['name']} --</option>
                        {content}
                    </select>
                </div>
            </div>
            { phoneNumberElement }
        </div>
    )

});

export default SelectDropdown;
